export default __webpack_public_path__ + "static/media/Logo.9341515d.png";